import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

const monthFormat = "YYYY-MM";

class UpdateTrainingExp extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.queryVitaeList('TRAINING_CONTENT');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            trainingOptions: [],
        });
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                if (typeName === 'TRAINING_CONTENT') {
                    this.setState({ trainingOptions: options });
                }
            }
        };
        $.sendRequest(options);
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const {
            trainingOptions = [],
        } = this.state;
        trainingOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: '培训内容',
            en: 'Training Content',
            key: 'trainingContentId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: trainingOptions,
                style: { width: 272 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
        }, {
            key: isChinese ? 'trainingCommentsChinese' : 'trainingCommentsEnglish',
            require: true,
            colon: false,
            option: {
                type: 'input',
                style: { width: 272 },
                placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
            },
            display: {
                symbol: 'eq',
                key: 'trainingContentId',
                toName: true,
                value: isChinese ? '其他' : 'Other',
            },
        }, [{
                zh: '培训时间',
                en: 'Training Date',
                key: 'startTime',
                require: true,
                option: {
                    type: 'monthPicker',
                    allowClear: false,
                    format: monthFormat,
                    disabled: !isChinese,
                    style: { width: 120 },
                    placeholder: isChinese ? '请选择' : 'Please select ',
                },
                attr: {
                    right: { width: 120 }
                },
            }, {
                zh: '到',
                en: 'To',
                key: 'endTime',
                colon: false,
                option: {
                    type: 'monthPicker',
                    allowClear: true,
                    format: monthFormat,
                    disabled: !isChinese,
                    style: { width: 120 },
                    placeholder: isChinese ? '不填写代表至今' : "Present",
                },
                attr: {
                    left: { width: 32, padding: '0 10px' },
                    right: { width: 120 },
                },
            }
        ]];
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const {
            isEdit,
            params,
            params: {
                startTime,
                endTime,
            }
        } = this.state;
        const { userId, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }
        if (isEdit) {
            params.startTime = startTime ? startTime.slice(0, 7) : startTime;
            params.endTime = endTime ? endTime.slice(0, 7) : endTime;
        }
        params.type = isChinese ? 'CHINESE' : 'ENGLISH',

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.saveTrainingExperience,
            data: {
                userId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        const { isChinese } = this.props;
        params[key] = value;
        if (key === 'trainingContentId') {
            const trainingComments = isChinese ? 'trainingCommentsChinese' : 'trainingCommentsEnglish';
            params[trainingComments] = '';
        }
        this.setState({ params });
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}培训经历`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="540px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateTrainingExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateTrainingExp.js